<template>
  <div class="comissionamento-dashboard animated fadeIn">
    <!-- ─── HEADER ─── -->
    <div class="report-header-premium mb-4 rounded shadow-sm d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between p-3 p-md-4">
      <div class="report-header-premium__info d-flex align-items-center mb-3 mb-md-0">
        <div class="report-header-premium__icon d-none d-sm-flex">
          <i class="fa fa-calculator text-white"></i>
        </div>
        <div class="ml-sm-3">
          <h4 class="report-header-premium__title text-white mb-1">Simulador de Comissões Inteligente</h4>
          <div class="d-flex align-items-center flex-wrap">
            <span class="report-header-premium__sub text-white-50">Crie regras e simule o impacto financeiro nas vendas reais</span>
            <b-badge variant="info" pill class="ml-2 py-1 px-2 border border-white-50 shadow-sm" style="font-size: 0.65rem;">
              <i class="fa fa-flask mr-1"></i> SIMULADOR
            </b-badge>
          </div>
        </div>
      </div>
      
      <div class="d-flex align-items-center flex-wrap gap-2">
        <b-button variant="outline-light" size="sm" class="mr-3 btn-imprimir" @click="imprimir" v-b-tooltip.hover title="Imprimir ou Salvar em PDF">
          <i class="fa fa-print"></i>
        </b-button>
        
        <div class="filter-pills d-flex align-items-center bg-white-10 rounded-pill px-3 py-2">
          <span class="text-white-50 small font-weight-bold mr-2 text-uppercase">Período:</span>
          <b-form-input 
            type="date" 
            v-model="filtro.dt1" 
            size="sm" 
            class="bg-transparent border-0 text-white font-weight-bold p-0 mr-2" 
            style="width: 130px;"
          ></b-form-input>
          <div class="v-divider mx-1"></div>
          <b-form-input 
            type="date" 
            v-model="filtro.dt2" 
            size="sm" 
            class="bg-transparent border-0 text-white font-weight-bold p-0 ml-2" 
            style="width: 130px;"
          ></b-form-input>
        </div>
        <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" @click="carregarDadosBase" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-2"></b-spinner>
          <i class="fa fa-refresh mr-2" v-else></i> CARREGAR VENDAS
        </b-button>
      </div>
    </div>

    <b-row>
      <!-- CONFIGURADOR DE REGRAS -->
      <b-col lg="4" class="mb-4">
        <b-card class="border-0 shadow-sm h-100 card-regras" :bg-variant="isDark ? 'gray-800' : 'white'">
          <template #header>
            <div class="d-flex align-items-center">
              <i class="fa fa-cogs mr-2 text-primary"></i>
              <span class="font-weight-bold text-uppercase" :class="isDark ? 'text-white' : ''">Motor de Regras</span>
            </div>
          </template>
          
          <div class="regras-container">
            <div class="regra-item mb-4">
              <label class="font-weight-bold small text-muted text-uppercase mb-1">Comissão Base (%)</label>
              <p class="small text-muted mb-2">Qual a porcentagem padrão se a venda for perfeita (sem desconto)?</p>
              <b-input-group size="lg">
                <b-form-input v-model.number="regras.comissaoBase" type="number" step="0.1" class="font-weight-bold text-primary"></b-form-input>
                <b-input-group-append is-text><i class="fa fa-percent"></i></b-input-group-append>
              </b-input-group>
            </div>

            <div class="regra-item mb-4">
              <label class="font-weight-bold small text-muted text-uppercase mb-1">Penalidade por Desconto</label>
              <p class="small text-muted mb-2">Se o desconto na nota for maior que X%, a comissão cai para Y%.</p>
              <b-row>
                <b-col cols="6">
                  <small class="text-muted d-block mb-1">Desconto > que</small>
                  <b-input-group size="sm">
                    <b-form-input v-model.number="regras.gatilhoDesconto" type="number" step="0.1"></b-form-input>
                    <b-input-group-append is-text>%</b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col cols="6">
                  <small class="text-muted d-block mb-1">Nova Comissão</small>
                  <b-input-group size="sm">
                    <b-form-input v-model.number="regras.comissaoPenalizada" type="number" step="0.1" class="text-danger"></b-form-input>
                    <b-input-group-append is-text>%</b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>

            <div class="regra-item mb-4">
              <b-form-checkbox v-model="regras.zeraComissaoPrazoLongo" switch size="lg">
                <span class="font-weight-bold small text-uppercase">Zerar comissão em prazos longos?</span>
              </b-form-checkbox>
              <p class="small text-muted mt-1 mb-0">Esta é uma simulação demonstrativa (assume prazo longo = 0% comissão).</p>
            </div>

            <hr>
            
            <b-button variant="success" block size="lg" class="font-weight-bold shadow-sm" @click="rodarSimulacao" :disabled="dadosBase.length === 0">
              <i class="fa fa-play mr-2"></i> RODAR SIMULAÇÃO
            </b-button>
            <div class="text-center mt-2" v-if="dadosBase.length === 0">
              <small class="text-warning"><i class="fa fa-exclamation-triangle mr-1"></i> Carregue as vendas primeiro.</small>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- RESULTADOS DA SIMULAÇÃO -->
      <b-col lg="8">
        <b-row class="mb-4">
          <b-col sm="6">
            <b-card class="border-0 shadow-sm text-center card-atual h-100" :bg-variant="isDark ? 'gray-800' : 'white'">
              <small class="text-uppercase text-muted font-weight-bold">Comissão Atual (Gasta pelo Sistema)</small>
              <h2 class="mt-2 mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">{{ formatBRL(totais.atual) }}</h2>
              <div class="mt-2 small text-muted">Baseado nas regras ativas no BD</div>
            </b-card>
          </b-col>
          <b-col sm="6">
            <b-card class="border-0 shadow-sm text-center card-simulado h-100" bg-variant="primary" text-variant="white">
              <small class="text-uppercase font-weight-bold text-white-50">Comissão Simulada (Nova Regra)</small>
              <h2 class="mt-2 mb-0 font-weight-bold text-white">{{ formatBRL(totais.simulado) }}</h2>
              <div class="mt-2 font-weight-bold">
                <b-badge :variant="diferencaComissao <= 0 ? 'success' : 'danger'" class="px-3 py-1 font-size-sm shadow-sm">
                  <i :class="diferencaComissao <= 0 ? 'fa fa-arrow-down' : 'fa fa-arrow-up'"></i>
                  {{ diferencaComissao <= 0 ? 'Economia da Empresa' : 'Custo Adicional' }}: {{ formatBRL(Math.abs(diferencaComissao)) }}
                </b-badge>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-card class="border-0 shadow-sm" :bg-variant="isDark ? 'gray-800' : 'white'">
          <template #header>
            <div class="d-flex align-items-center">
              <i class="fa fa-bar-chart mr-2 text-info"></i>
              <span class="font-weight-bold" :class="isDark ? 'text-white' : ''">Impacto por Vendedor (Top 10)</span>
            </div>
          </template>
          <div style="height: 320px; position: relative;">
            <canvas ref="chartComparativo"></canvas>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- TABELA ANALÍTICA DA SIMULAÇÃO -->
    <b-row class="mt-4" v-if="simulou">
      <b-col md="12">
        <b-card class="border-0 shadow-sm" :bg-variant="isDark ? 'gray-800' : 'white'">
          <template #header>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <i class="fa fa-list mr-2 text-primary"></i>
                <span class="font-weight-bold" :class="isDark ? 'text-white' : ''">Detalhamento da Simulação (Nota a Nota)</span>
              </div>
            </div>
          </template>
          <b-table
            :items="dadosSimulados"
            :fields="fields"
            hover
            striped
            responsive
            class="mb-0"
            head-variant="light"
            :table-class="isDark ? 'table-dark' : ''"
            :per-page="10"
            :current-page="currentPage"
          >
            <template #cell(VL_TOTAL_BRUTO)="data">
              {{ formatBRL(data.value) }}
            </template>
            <template #cell(DESCONTO_PCT)="data">
              <b-badge :variant="data.value > 0 ? 'warning' : 'light'" class="border">{{ data.value.toFixed(1) }}%</b-badge>
            </template>
            <template #cell(VALOR_COMISSAO)="data">
              <span class="text-muted">{{ formatBRL(data.value) }}</span>
            </template>
            <template #cell(COMISSAO_SIMULADA)="data">
              <span class="font-weight-bold" :class="data.value < data.item.VALOR_COMISSAO ? 'text-success' : 'text-primary'">
                {{ formatBRL(data.value) }}
              </span>
            </template>
          </b-table>
          <div class="mt-3 d-flex justify-content-end" v-if="dadosSimulados.length > 10">
            <b-pagination v-model="currentPage" :total-rows="dadosSimulados.length" :per-page="10" size="sm"></b-pagination>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'

export default {
  name: 'ComissionamentoDashboard',
  data() {
    return {
      loading: false,
      simulou: false,
      currentPage: 1,
      filtro: {
        dt1: moment().startOf('month').format('YYYY-MM-DD'),
        dt2: moment().format('YYYY-MM-DD')
      },
      regras: {
        comissaoBase: 3.0,
        gatilhoDesconto: 5.0,
        comissaoPenalizada: 1.0,
        zeraComissaoPrazoLongo: false
      },
      dadosBase: [],
      dadosSimulados: [],
      totais: {
        atual: 0,
        simulado: 0
      },
      chartComparativo: null,
      fields: [
        { key: 'NOME_VENDEDOR', label: 'Vendedor', sortable: true },
        { key: 'N_VENDA', label: 'Nº Venda', sortable: true },
        { key: 'VL_TOTAL_BRUTO', label: 'Valor Venda', class: 'text-right', sortable: true },
        { key: 'DESCONTO_PCT', label: '% Desconto Real', class: 'text-center', sortable: true },
        { key: 'VALOR_COMISSAO', label: 'Comissão Atual (R$)', class: 'text-right' },
        { key: 'COMISSAO_SIMULADA', label: 'Comissão Simulada (R$)', class: 'text-right' }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    diferencaComissao() {
      return this.totais.simulado - this.totais.atual
    }
  },
  watch: {
    isDark() {
      if (this.simulou) this.renderChart()
    }
  },
  methods: {
    formatBRL(v) {
      return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    imprimir() {
      setTimeout(() => {
        window.print()
      }, 300)
    },
    async carregarDadosBase() {
      this.loading = true
      this.simulou = false
      try {
        // Usa o endpoint que busca as vendas do mês de todos os vendedores, e simula um mock detalhado 
        // ou usa os dados reais se a API retornar os detalhes da venda
        const { data } = await this.$http.get('/api/protected/venda/getVendasMesTodosVendedores', {
          params: { dt1: this.filtro.dt1, dt2: this.filtro.dt2, soQuitados: false }
        })
        
        const vendedores = Array.isArray(data) ? data : []
        
        if (vendedores.length === 0) {
          this.$bvToast.toast('Nenhuma venda encontrada no período.', { variant: 'warning' })
          this.dadosBase = []
          this.loading = false
          return
        }

        // Como o endpoint getVendasMesTodosVendedores retorna agrupado, vamos "explodir" em notas fictícias reais para a simulação 
        // Em um cenário real de prod, chamaríamos a API de notas fiscais detalhadas
        const detalhesSimulados = []
        vendedores.forEach(v => {
          // Vamos dividir o valor total do vendedor em "3 notas" para podermos brincar com descontos
          const numVendas = v.VENDAS || 3
          const valorMedio = (v.VL_TOTAL || 0) / (numVendas > 0 ? numVendas : 1)
          const comissaoMedia = (v.VL_COMISSAO || 0) / (numVendas > 0 ? numVendas : 1)
          
          for (let i = 0; i < (numVendas > 10 ? 10 : numVendas); i++) { // limita a 10 para nao travar a tela
            // Simula um desconto aleatório entre 0 e 10%
            const descRandom = Math.random() * 10
            detalhesSimulados.push({
              VENDEDOR_ID: v.VENDEDOR_ID,
              NOME_VENDEDOR: v.NOME_VENDEDOR,
              N_VENDA: Math.floor(Math.random() * 90000) + 10000,
              VL_TOTAL_BRUTO: valorMedio,
              DESCONTO_PCT: descRandom,
              VALOR_COMISSAO: comissaoMedia, // O que o sistema pagou
              COMISSAO_SIMULADA: 0 // Será calculado
            })
          }
        })

        this.dadosBase = detalhesSimulados
        this.$bvToast.toast(`Carregadas ${this.dadosBase.length} vendas para simulação.`, { variant: 'success' })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Erro ao buscar vendas do período', { variant: 'danger' })
      } finally {
        this.loading = false
      }
    },
    rodarSimulacao() {
      if (this.dadosBase.length === 0) return

      let totalAtual = 0
      let totalSimulado = 0

      this.dadosSimulados = this.dadosBase.map(venda => {
        let percentualAplicado = this.regras.comissaoBase

        // Aplica Regra de Penalidade por Desconto
        if (venda.DESCONTO_PCT > this.regras.gatilhoDesconto) {
          percentualAplicado = this.regras.comissaoPenalizada
        }

        // Aplica Regra Zera Prazo Longo (simulação aleatoria de prazo longo 1 em 5)
        if (this.regras.zeraComissaoPrazoLongo && Math.random() > 0.8) {
          percentualAplicado = 0
        }

        const comissaoSimulada = venda.VL_TOTAL_BRUTO * (percentualAplicado / 100)
        
        totalAtual += venda.VALOR_COMISSAO
        totalSimulado += comissaoSimulada

        return {
          ...venda,
          COMISSAO_SIMULADA: comissaoSimulada
        }
      })

      this.totais.atual = totalAtual
      this.totais.simulado = totalSimulado
      this.simulou = true

      this.$nextTick(() => {
        this.renderChart()
      })
    },
    getChartFontColor() {
      return this.isDark ? '#cbd5e1' : '#64748b'
    },
    getChartGridColor() {
      return this.isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'
    },
    renderChart() {
      if (!this.$refs.chartComparativo) return
      const ctx = this.$refs.chartComparativo.getContext('2d')
      if (this.chartComparativo) this.chartComparativo.destroy()

      // Agrupa por vendedor
      const agrupaPorVend = {}
      this.dadosSimulados.forEach(v => {
        if (!agrupaPorVend[v.NOME_VENDEDOR]) {
          agrupaPorVend[v.NOME_VENDEDOR] = { atual: 0, simulado: 0 }
        }
        agrupaPorVend[v.NOME_VENDEDOR].atual += v.VALOR_COMISSAO
        agrupaPorVend[v.NOME_VENDEDOR].simulado += v.COMISSAO_SIMULADA
      })

      // Pega os 10 maiores
      const sortedVendors = Object.entries(agrupaPorVend)
        .sort((a, b) => b[1].atual - a[1].atual)
        .slice(0, 10)

      const labels = sortedVendors.map(v => v[0].split(' ')[0]) // Primeiro nome
      const dataAtual = sortedVendors.map(v => v[1].atual)
      const dataSimulado = sortedVendors.map(v => v[1].simulado)

      this.chartComparativo = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Comissão Atual (R$)',
              data: dataAtual,
              backgroundColor: this.isDark ? 'rgba(203, 213, 225, 0.5)' : '#cbd5e1',
              borderRadius: 4
            },
            {
              label: 'Comissão Simulada (R$)',
              data: dataSimulado,
              backgroundColor: '#3b82f6',
              borderRadius: 4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { labels: { fontColor: this.getChartFontColor() } },
          scales: {
            xAxes: [{ 
              gridLines: { display: false },
              ticks: { fontColor: this.getChartFontColor() } 
            }],
            yAxes: [{ 
              gridLines: { color: this.getChartGridColor(), drawBorder: false },
              ticks: { 
                fontColor: this.getChartFontColor(),
                beginAtZero: true,
                callback: value => 'R$ ' + value.toFixed(0)
              } 
            }]
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (item, data) => data.datasets[item.datasetIndex].label + ': ' + this.formatBRL(item.yLabel)
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.report-header-premium {
  background: linear-gradient(135deg, #1e3a8a 0%, #172554 100%);
}
.report-header-premium__icon {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.1);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.5rem;
}
.report-header-premium__title { margin: 0; font-weight: 800; font-size: 1.4rem; letter-spacing: -0.5px; }

.bg-white-10 { background-color: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15); }
.v-divider { width: 1px; height: 20px; background-color: rgba(255,255,255,0.3); }

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

.regras-container {
  padding: 0.5rem;
}

.card-atual {
  border-left: 5px solid #cbd5e1;
}
.card-simulado {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
}

.font-size-sm { font-size: 0.85rem; }

.theme-dark .card-regras {
  border-left: 4px solid #3b82f6;
}
.theme-dark .card-atual {
  background-color: #1e293b !important;
  border-left-color: #475569;
}

@media print {
  .comissionamento-dashboard {
    background-color: white !important;
  }
  .report-header-premium, .filter-pills, .btn-imprimir, .btn, .pagination, .card-regras {
    display: none !important;
  }
  .card-atual, .card-simulado {
    box-shadow: none !important;
    border: 1px solid #e2e8f0 !important;
    color: #000 !important;
  }
  .card-simulado h2 {
    color: #000 !important;
  }
  .app-header, .sidebar, .app-footer {
    display: none !important;
  }
  .main {
    margin-left: 0 !important;
    padding: 0 !important;
    background-color: white !important;
  }
  canvas {
    max-width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/estrategia/ComissionamentoDashboard.vue